import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import ProfileLogs from "../components/ProfileLogs";
// import LatestActivities from "../components/LatestActivities";
import CustomLogs from "./CustomLogs";
import { useParams } from "react-router-dom";
import { api } from "../utils/axios-instance";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ProfileTabs() {
  const [value, setValue] = useState(0);

  // const [logs, setLogs] = useState([]);
  const [sharedLogs, setSharedLogs] = useState([]);
  const [receivedLogs, setReceivedLogs] = useState([]);
  const [latestLogs, setLatestLogs] = useState([]);
  const [downloadLogs, setDownloadLogs] = useState([]);

  const { userId } = useParams();

  useEffect(() => {
    const fetchLogs = async () => {
      const results = await Promise.allSettled([
        api.get(`/users/getUserInfo/${userId}?type=shared`),
        api.get(`/users/getUserInfo/${userId}?type=received`),
        api.get(`/users/getUserInfo/${userId}/?logs=1&recs=15`),
      ]);

      const sharedRes = results[0];
      const receivedRes = results[1];
      const latestRes = results[2];

      setSharedLogs(sharedRes.status === "fulfilled" ? (sharedRes.value.data.files || []) : []);
      setReceivedLogs(receivedRes.status === "fulfilled" ? (receivedRes.value.data.files || []) : []);

      const l = latestRes.status === "fulfilled" ? (latestRes.value.data || []) : [];
      setLatestLogs(l);
      setDownloadLogs(l.filter((log) => log.event === "download"));
    };

    //   if (sharedRes.status === "fulfilled") {
    //     setSharedLogs(sharedRes.value?.data?.files || []);
    //   } else {
    //     console.error("shared logs failed:", sharedRes.reason);
    //     setSharedLogs([]);
    //   }

    //   if (receivedRes.status === "fulfilled") {
    //     setReceivedLogs(receivedRes.value?.data?.files || []);
    //   } else {
    //     console.error("received logs failed:", receivedRes.reason);
    //     setReceivedLogs([]);
    //   }

    //   if (latestRes.status === "fulfilled") {
    //     const logs = latestRes.value?.data || [];
    //     setLatestLogs(logs);

    //     setDownloadLogs(logs.filter((log) => log.event === "download"));
    //   } else {
    //     console.error("latest logs failed:", latestRes.reason);
    //     setLatestLogs([]);
    //     setDownloadLogs([]);
    //   }
    // };

    if (userId) fetchLogs();
  }, [userId]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab
            label="File Shared to"
            {...a11yProps(0)}
            sx={{ textTransform: "capitalize", fontSize: "small" }}
          />
          <Tab
            label="File Shared from"
            {...a11yProps(1)}
            sx={{ textTransform: "capitalize", fontSize: "small" }}
          />
          <Tab
            label="User Activity"
            {...a11yProps(2)}
            sx={{ textTransform: "capitalize", fontSize: "small" }}
          />
          <Tab
            label="Download"
            {...a11yProps(3)}
            sx={{ textTransform: "capitalize", fontSize: "small" }}
          />
          <Tab
            label="Edited Files"
            {...a11yProps(4)}
            sx={{ textTransform: "capitalize", fontSize: "small" }}
          />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <ProfileLogs logs={sharedLogs} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <ProfileLogs logs={receivedLogs} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <CustomLogs logs={latestLogs} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>
        <CustomLogs logs={downloadLogs} />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        Edited Files
      </CustomTabPanel>
    </Box>
  );
}
